module.exports = __webpack_public_path__ + "src/assets/img/m-item3.c77148bb.png";